import Modal from './modal';
import Cookies from './cookies';
import Storage from './storage';

export const cookies = new Cookies();
export const modal = new Modal();
export const storage = new Storage();

export { observer } from 'mobx-react-lite';
